import {dom, library} from '@fortawesome/fontawesome-svg-core'
import {faFacebookF, faInstagram, faLinkedin, faXTwitter} from "@fortawesome/free-brands-svg-icons";
import {faCalendar as faCalendarRegular, faEnvelope, faMap} from "@fortawesome/free-regular-svg-icons";
import {
    faAngleLeft,
    faAngleRight,
    faAnglesLeft,
    faAnglesRight,
    faCalendar as faCalendarSolid,
    faCalendarDays, faCircleCheck,
    faDownload,
    faEnvelope as faEnvelopeSolid,
    faGrip,
    faList,
    faMagnifyingGlass,
    faMedal,
    faMobile,
    faPencil,
    faImages,
    faHouse,
    faPhone,
    faPlus,
    faSearch,
    faShareNodes,
    faXmark, faCopy, faCodeBranch, faEye, faPeopleGroup, faListCheck, faFilePen, faCircleExclamation, faEyeSlash,
    faFileArrowDown, faCircleInfo
} from "@fortawesome/free-solid-svg-icons";

const iconRegular = [
    faEnvelope,
    faMap,
    faCalendarRegular,
];
const iconSolid = [
    faCircleInfo,
    faFileArrowDown,
    faPhone,
    faMagnifyingGlass,
    faAngleLeft,
    faAngleRight,
    faAnglesLeft,
    faAnglesRight,
    faMedal,
    faSearch,
    faMobile,
    faCalendarSolid,
    faPlus,
    faPencil,
    faImages,
    faHouse,
    faXmark,
    faDownload,
    faShareNodes,
    faEnvelopeSolid,
    faGrip,
    faList,
    faCalendarDays,
    faCircleCheck,
    faCopy,
    faCodeBranch,
    faEye,
    faPeopleGroup,
    faListCheck,
    faFilePen,
    faCircleExclamation,
    faEyeSlash
];

const iconBrands = [
    faFacebookF,
    faXTwitter,
    faInstagram,
    faLinkedin
];

library.add(iconBrands, iconRegular, iconSolid)
dom.watch()
